var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNovapointBridgeSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointBridge_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,19,28,7V6H26V7.16c-3.05,3.07-7.85,7.19-9.95,7.19h0c-2.1,0-6.95-4.15-10-7.2V6H4v.87L0,19H0v4.06H3V28H7V23.05H24.92V28h4V23.05H32V19ZM1.1,19,4,10.23V19ZM6,19V9.72c.58.57,1.26,1.2,2,1.86V19Zm3-6.54c.65.55,1.32,1.08,2,1.57v5H9ZM12,19V14.71a14,14,0,0,0,2,1.11V19Zm3,0v-2.8a4,4,0,0,0,1,.16H16a3.79,3.79,0,0,0,1-.14V19Zm3,0V15.88a14.48,14.48,0,0,0,2-1.06V19Zm3,0V14.16c.68-.48,1.35-1,2-1.52V19Zm3,0V11.8c.74-.64,1.42-1.27,2-1.82v9Zm4,0V10.23L30.9,19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointBridgeSvg);
export default __webpack_public_path__ + "static/media/NovapointBridge_svg.c7b3e6cc482e55642a9eab9ca9b1b042.svg";
export { ForwardRef as ReactComponent };